// Страница «Все кейсы»: фильтр по тегам, «Показать еще» и липкая плашка фильтра на телефоне.
// Теги карточек лежат в разметке (data-tags="1,6" — номера ключей cases.tags.itemN).
// Выбор одиночный, как на старой странице: клик по тегу — в фильтре или на плашке под карточкой —
// показывает только его кейсы и подсвечивает тег, повторный клик по активному тегу снимает фильтр.
// При клике по плашке карточка остаётся на том же месте экрана — список не «прыгает».

const section = document.querySelector('.cases-page__list');

if (section) {
  const grid = section.querySelector('[data-cases-grid]');
  const cards = Array.from(grid.querySelectorAll('.cases-page__card'));
  const moreWrapper = section.querySelector('.cases-page__more');
  const moreButton = section.querySelector('[data-cases-more]');
  const filter = section.querySelector('[data-cases-filter]');
  const header = document.querySelector('header');

  const phoneQuery = window.matchMedia('(max-width: 667px)');

  // сколько карточек показываем сразу и добавляем по кнопке: 6 — ряды по 3 и по 2 всегда полные
  const BATCH_SIZE = 6;
  const getBatchSize = () => BATCH_SIZE;

  let activeTag = null;
  let visibleCount = getBatchSize();

  const cardTags = new Map(cards.map((card) => [card, (card.dataset.tags || '').split(',').filter(Boolean)]));

  const getMatchingCards = () =>
    activeTag ? cards.filter((card) => cardTags.get(card).includes(activeTag)) : cards;

  const render = () => {
    const matching = getMatchingCards();

    cards.forEach((card) => {
      card.hidden = true;
    });
    matching.slice(0, visibleCount).forEach((card) => {
      card.hidden = false;
    });

    moreWrapper.hidden = matching.length <= visibleCount;
  };

  /* ---------- липкая плашка (телефон) ---------- */
  // Копия фильтра, которая фиксируется под шапкой, пока пользователь листает карточки.
  // В потоке остаётся исходный фильтр, поэтому при появлении плашки контент не прыгает.
  const sticky = document.createElement('div');
  sticky.className = 'cases-page__sticky';
  const stickyFilter = filter.cloneNode(true);
  const stickyTitle = stickyFilter.querySelector('.cases-page__filter__title');
  const stickyTitleReplacement = document.createElement('div');
  stickyTitleReplacement.className = stickyTitle.className;
  stickyTitleReplacement.innerHTML = stickyTitle.innerHTML;
  stickyTitle.replaceWith(stickyTitleReplacement);
  stickyFilter.classList.add('is-collapsed');
  stickyFilter.querySelector('[data-cases-filter-toggle]').setAttribute('aria-expanded', 'false');
  sticky.appendChild(stickyFilter);
  section.appendChild(sticky);

  const filters = [filter, stickyFilter];
  const tagButtons = filters.flatMap((element) => Array.from(element.querySelectorAll('.cases-page__tag')));
  const cardTagPills = Array.from(grid.querySelectorAll('.cases-page__card__tag[data-tag]'));

  const setCollapsed = (element, collapsed) => {
    element.classList.toggle('is-collapsed', collapsed);
    element.querySelector('[data-cases-filter-toggle]').setAttribute('aria-expanded', String(!collapsed));
  };

  const getHeaderBottom = () => (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0);

  const updateSticky = () => {
    if (!phoneQuery.matches) {
      sticky.classList.remove('is-visible');
      return;
    }

    // шапка становится fixed после 30px прокрутки (script.js); плашку ставим сразу под ней
    const headerBottom = getHeaderBottom();
    sticky.style.setProperty('--cases-sticky-top', `${headerBottom}px`);

    // высота свёрнутой плашки: заголовок 32px + поля 16px + рамка
    const barHeight = stickyFilter.querySelector('.cases-page__filter__head').offsetHeight + 33;
    const filterRect = filter.getBoundingClientRect();
    const gridRect = grid.getBoundingClientRect();
    // показываем, когда теги в потоке почти целиком ушли под место плашки, и прячем, когда список закончился
    const isVisible = filterRect.bottom <= headerBottom + barHeight && gridRect.bottom > headerBottom + barHeight;

    if (!isVisible && sticky.classList.contains('is-visible')) {
      setCollapsed(stickyFilter, true);
    }
    sticky.classList.toggle('is-visible', isVisible);
  };

  const scrollToGrid = () => {
    // шапка (после прокрутки она fixed) + свёрнутая плашка на телефоне
    const headerHeight = header && header.classList.contains('fixed') ? header.offsetHeight : 71;
    const barHeight = phoneQuery.matches ? stickyFilter.querySelector('.cases-page__filter__head').offsetHeight + 33 : 0;
    const top = grid.getBoundingClientRect().top + window.pageYOffset - headerHeight - barHeight - 16;

    window.scrollTo({ top, behavior: 'smooth' });
  };

  /* ---------- обработчики ---------- */
  const setActiveTag = (tag) => {
    activeTag = activeTag === tag ? null : tag;

    tagButtons.forEach((button) => {
      const isActive = button.dataset.tag === activeTag;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });
    cardTagPills.forEach((pill) => {
      const isActive = pill.dataset.tag === activeTag;
      pill.classList.toggle('is-active', isActive);
      pill.setAttribute('aria-pressed', String(isActive));
    });
  };

  const onTagClick = (event) => {
    const tag = event.currentTarget.dataset.tag;
    const fromSticky = stickyFilter.contains(event.currentTarget);

    setActiveTag(tag);
    visibleCount = getBatchSize();

    render();

    if (fromSticky) {
      setCollapsed(stickyFilter, true);
    }

    // если начало сетки уже ушло за шапку — возвращаем к первой карточке
    if (grid.getBoundingClientRect().top < getHeaderBottom()) {
      scrollToGrid();
    }

    updateSticky();
  };

  tagButtons.forEach((button) => button.addEventListener('click', onTagClick));

  // Плашка тега под карточкой: фильтрует список, а не открывает кейс. Карточка, по которой кликнули,
  // остаётся видимой (порцию расширяем до неё) и на том же месте экрана — прокрутку поправляем
  // на величину сдвига без анимации, поэтому скачка не видно.
  const onCardTagClick = (pill) => {
    const card = pill.closest('.cases-page__card');
    const topBefore = card.getBoundingClientRect().top;

    setActiveTag(pill.dataset.tag);

    const position = getMatchingCards().indexOf(card) + 1;
    visibleCount = Math.max(getBatchSize(), Math.ceil(position / getBatchSize()) * getBatchSize());

    render();

    window.scrollBy(0, card.getBoundingClientRect().top - topBefore);
    updateSticky();
  };

  grid.addEventListener('click', (event) => {
    const pill = event.target.closest('.cases-page__card__tag[data-tag]');
    if (!pill) return;
    event.preventDefault();
    onCardTagClick(pill);
  });

  grid.addEventListener('keydown', (event) => {
    const pill = event.target.closest('.cases-page__card__tag[data-tag]');
    if (!pill || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    onCardTagClick(pill);
  });

  filters.forEach((element) => {
    element.querySelector('[data-cases-filter-toggle]').addEventListener('click', () => {
      setCollapsed(element, !element.classList.contains('is-collapsed'));
      updateSticky();
    });
  });

  moreButton.addEventListener('click', () => {
    visibleCount += getBatchSize();
    render();
  });

  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);

  render();
  updateSticky();
}
